module.exports = __webpack_public_path__ + "img/和美@2x.f6c509bd.png";